import React, { useState } from 'react';

const PersonalityStep = ({ onComplete, onBack, initialAnswers }) => {
  const [selectedPersonality, setSelectedPersonality] = useState(
    initialAnswers?.personality || ''
  );

  const personalities = [
    {
      id: 'innocent_heroine',
      emoji: '🌸',
      title: 'The Innocent Heroine',
      description: 'Sweet, pure-hearted, and trusting with natural grace'
    },
    {
      id: 'fiery_spirit',
      emoji: '🔥',
      title: 'The Fiery Spirit',
      description: 'Bold, passionate, and confident with magnetic energy'
    },
    {
      id: 'tragic_queen',
      emoji: '👑',
      title: 'The Tragic Queen',
      description: 'Regal, powerful, with deep emotional complexity'
    },
    {
      id: 'mischievous_fairy',
      emoji: '🧚‍♀️',
      title: 'The Mischievous Fairy',
      description: 'Playful, clever, and enchanting with sparkling wit'
    },
    {
      id: 'mysterious_seductress',
      emoji: '🌙',
      title: 'The Mysterious Seductress',
      description: 'Alluring, dramatic, and captivating with magnetic presence'
    },
    {
      id: 'noble_warrior',
      emoji: '⚔️',
      title: 'The Noble Warrior',
      description: 'Strong, brave, and dignified with unwavering determination'
    }
  ];

  const handleSelectPersonality = (personalityId) => {
    setSelectedPersonality(personalityId);
  };

  const handleNext = () => {
    if (selectedPersonality) {
      const selectedOption = personalities.find(p => p.id === selectedPersonality);
      onComplete({ personality: selectedOption.title });
    }
  };

  return (
    <div className="quiz-step">
      <h2>If you were a character in a ballet story, what kind of role would you play?</h2>
      <p>Choose the character archetype that resonates most with your natural stage personality.</p>
      
      <div className="options-grid">
        {personalities.map((personality) => (
          <div
            key={personality.id}
            className={`option-card ${selectedPersonality === personality.id ? 'selected' : ''}`}
            onClick={() => handleSelectPersonality(personality.id)}
          >
            <h3>
              <span className="emoji">{personality.emoji}</span>
              {personality.title}
            </h3>
            <p>{personality.description}</p>
          </div>
        ))}
      </div>

      <div className="quiz-buttons">
        <button className="btn-back" onClick={onBack}>
          ← Back
        </button>
        <button 
          className="btn-next" 
          onClick={handleNext}
          disabled={!selectedPersonality}
        >
          Next Step →
        </button>
      </div>
    </div>
  );
};

export default PersonalityStep; 